import React from 'react';

const PosterPlaceholder = () => {
  return (
    <div
      style={{
        backgroundColor: '#f2f2f2',
        width: '100%',
        height: '400px',
        textAlign: 'center',
      }}
      id='Large placeholder poster'
    ></div>
  );
};

export default PosterPlaceholder;
